import { ModuleStatesConstructorsByName } from '@gongxigames/framework/slot/fragments/module/Module';

import { MultiSetsPromotionDisabledState } from './MultiSetsPromotionDisabledState';
import { MultiSetsPromotionEndState } from './MultiSetsPromotionEndState';
import { MultiSetsPromotionInProgressState } from './MultiSetsPromotionInProgressState';
import { MultiSetsPromotionInitState } from './MultiSetsPromotionInitState';
import { MultiSetsPromotionBasicState } from './MultiSetsPromotionBasicState';
import { MultiSetsPromotionRestoreState } from './MultiSetsPromotionRestoreState';
import { MultiSetsPromotionStartState } from './MultiSetsPromotionStartState';
import { MultiSetsPromotionStates } from '../MultiSetsPromotionStates';

export const MultiSetsPromotionStatesMap: ModuleStatesConstructorsByName = {
    [MultiSetsPromotionStates.INIT]: MultiSetsPromotionInitState,
    [MultiSetsPromotionStates.BASIC]: MultiSetsPromotionBasicState,
    [MultiSetsPromotionStates.RESTORE]: MultiSetsPromotionRestoreState,
    [MultiSetsPromotionStates.START]: MultiSetsPromotionStartState,
    [MultiSetsPromotionStates.IN_PROGRESS]: MultiSetsPromotionInProgressState,
    [MultiSetsPromotionStates.END]: MultiSetsPromotionEndState,
    [MultiSetsPromotionStates.DISABLED]: MultiSetsPromotionDisabledState,
};
